import React, { useEffect } from 'react';
import Banner from '../../components/Banner/Banner';
import { about, banner, features, reviews, video, plans, scan } from '../../components/Data';
import Features from '../../components/Features/Features';
import Video from '../../components/Video/Video';
import About from '../../components/About/About';
import Reviews from '../../components/Reviews/Reviews';
import Scan from '../../components/Scan/Scan';
import ResponsiveTable from '../../components/Plan/Plan';

const Home = () => {
    useEffect(() => {
        const scrollToSection = () => {
            const hash = window.location.hash;
            if (hash) {
                const sectionId = hash.substring(1);
                const section = document.getElementById(sectionId);
                if (section) {
                    const header = document.querySelector('header');
                    const headerHeight = header ? header.offsetHeight : 0;
                    const sectionPosition = section.getBoundingClientRect().top + window.scrollY;
                    const offsetPosition = sectionPosition - headerHeight;

                    window.scrollTo({
                        top: offsetPosition,
                        behavior: 'smooth'
                    });
                }
            } else {
                // Scroll to top if no hash is present
                window.scrollTo(0, 0);
            }
        };

        scrollToSection();
        window.addEventListener('hashchange', scrollToSection);

        return () => {
            window.removeEventListener('hashchange', scrollToSection);
        };
    }, []);

    return (
        <>
            <Banner banner={banner}/>
            <Features features={features}/>
            <Video video={video}/>
            <About about={about}/>
            <Reviews reviews={reviews}/>
            <ResponsiveTable {...plans}/>
            <Scan {...scan} />
        </>
    )
}

export default Home;